export const translatableFields: Record<string, string[]> = {
  'entities:custom_field_def': ['label', 'description'],
}

export default translatableFields
